var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecurity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.153,
    height: 36,
    viewBox: "0 0 28.153 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-lock",
    "data-name": "Icon ionic-ios-lock",
    d: "M29.634,15.144H27.673V11.327a7.846,7.846,0,1,0-15.692-.106v3.923H10.019A3.279,3.279,0,0,0,6.75,18.413V34.105a3.279,3.279,0,0,0,3.269,3.269H29.634A3.279,3.279,0,0,0,32.9,34.105V18.413A3.279,3.279,0,0,0,29.634,15.144Zm-8.663,10.2v5.623a1.172,1.172,0,0,1-1.087,1.177A1.146,1.146,0,0,1,18.682,31V25.344a2.615,2.615,0,1,1,2.288,0Zm4.413-10.2H14.269V11.221a5.558,5.558,0,0,1,11.115,0Z",
    transform: "translate(-5.75 -2.374)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.25bfc7b54f71394b0ca7804130981eb5.svg";
export { ForwardRef as ReactComponent };